//Kendo includes enabled/disabled bindings out of the box.
//However, those bindings try to call readonly as well.
//That is incompatible with DF's readonly binding.

export const Enabled = kendo.data.binders.widget.enabled = kendo.data.Binder.extend({
    _getEnable: function() {
        return !!this.bindings.enabled.get();
    },
    refresh: function() {
        //The enabled binding must support being used as a no-op on items that don't implement enable
        if(this.element.enable) {
            this.element.enable(this._getEnable());
        }
    }
});

export const Disabled = kendo.data.binders.widget.disabled = Enabled.extend({
    _getEnable: function() {
        return !this.bindings.disabled.get();
    }
});
